import React, { useState } from "react";
import "./Common_todays_offer_Card.css";
import Heart_icon from "../heart_icon/Heart_icon";
import Green_Btn from "../common_btn/green_btn/Green_Btn";
import { useNavigate } from "react-router-dom";
import IncrementDecrementBtn from "../Increment_Decrement_Btn/Increment_Decrement_Btn";
import { useDispatch, useSelector } from "react-redux";

import { encodeId } from "../../../utils/common";
import Select_Product_Cart_Modal from "../common_modal/select_product_by_weight_modal/Select_Product_By_Cart_Modal";

function Common_todays_offer_Card({ item, product, ...props }) {
  const navigate = useNavigate();
  const [selectedVariant, setSelectedVariant] = useState({});
  const allCart = useSelector((state) => state.cart.allCarts);
  const [addcartmodal, Setaddcartmodal] = useState(false);
  const [showIncrement, setShowIncrement] = useState(false);
  const isSignin = useSelector((state) => state.auth.is_signin);
  const isIn = allCart?.data?.data?.some(
    (item) => item?.variant_id === selectedVariant?.id
  );
  return (
    <>
      <section className="Common_todays_offer_Card Product_Info_Grid_View_Section">
        <div className="container Product_Info_Grid_View ">
          <div className="row">
            <div
              className="col-4 p-0"
              onClick={() =>
                navigate(`/product-description/${encodeId(product?.id)}`)
              }
            >
              <div className="img_holder">
                <img
                  src={process.env.REACT_APP_IMG_URL + props?.prodImg}
                  alt=""
                  className="product_img"
                />
              </div>
            </div>
            <div className="col-8 p-0">
              <div className="text_holder">
                <div className="text_div">
                  <div className="discont_div">
                    <p className="discount_text">
                     {item?.Discount_Type?.id === 1
                        ? `₹ ${item?.discount} `
                        : `${item?.discount} % `}
                       Off
                    </p>
                  </div>
                </div>
                <div className="lower_text_section">
                  <p
                    className="product_name"
                    onClick={() =>
                      navigate(`/product-description/${encodeId(product?.id)}`)
                    }
                  >
                    {props?.prodName}
                  </p>

                  <div className="pricing_div">
                    <div
                      className="left_side"
                      onClick={() =>
                        navigate(
                          `/product-description/${encodeId(product?.id)}`
                        )
                      }
                    >
                      <p className="selling_price">
                        ₹{product?.Product_Variants[0]?.price}
                      </p>
                      <p className="mrp">
                        {" "}
                        ₹{product?.Product_Variants[0]?.mrp}
                      </p>

                      {/* <div className='discount_div'>
                                                <p className='discount'>{product?.discount}</p>
                                            </div> */}
                    </div>

                    <div className="text-center btn_holder">
                      <>
                        {/* {isIn ? (
                          <IncrementDecrementBtn
                            varientId={selectedVariant?.id}
                            cart={allCart?.data?.data}
                            productId={product?.id}
                            product={product}
                            isSignIn={isSignin}
                          />
                        ) : ( */}
                        <div className="">
                          <Green_Btn
                            btn_name="Add "
                            // leftIcon={faBasketShopping}
                            onClick={() => {
                              setShowIncrement(true);
                              Setaddcartmodal(true);
                            }}
                          />
                        </div>
                        {/* )} */}
                      </>
                    </div>
                  </div>

                  <Heart_icon product={product} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Select_Product_Cart_Modal
          varient={product?.Product_Variants}
          selectedVariant={selectedVariant}
          setSelectedVariant={setSelectedVariant}
          product={product}
          show={addcartmodal}
          onHide={() => Setaddcartmodal(false)}
        />
      </section>
    </>
  );
}

export default Common_todays_offer_Card;
